import { int } from '@/hooks/useUrlState';

/** The /recognition-day-sessions query string (see README "List pages, URL state"). */
export const recognitionDaySessionsUrlSchema = {
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 50),
};
